import React from "react";

export default function PageHeader({ index, title, lead, right }) {
  return (
    <section className="bg-[#F7F6F2] border-b border-[#E2E0D8] pt-[118px] sm:pt-[130px] lg:pt-[170px] pb-14 lg:pb-20">
      <div className="shell">
        <p className="mono text-[9.5px] text-[#6B675F] mb-8">{index}</p>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <h1 className="lg:col-span-7 display text-[36px] sm:text-[58px] lg:text-[88px] text-[#141414]">
            {title}
          </h1>
          <div className="lg:col-span-4 lg:col-start-9">
            {lead && (
              <p className="text-[15px] lg:text-[16px] leading-relaxed text-[#141414]/70">{lead}</p>
            )}
            {right}
          </div>
        </div>
      </div>
    </section>
  );
}
